import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export default function UpgradeTirePackagePage({ packageData }) {
    const { wheel, tireOptions = [] } = packageData;
    // console.log("wheel",wheel);

    const [loader, setLoader] = useState(false);

    const PACKAGE_QTY = 4;
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;

    const navigate = useNavigate();

    const [selectedTire, setSelectedTire] = useState(tireOptions?.[0] || null);


    const wheelPrice = Number(wheel?.price || 0);
    const tirePrice = Number(selectedTire?.tire_price || 0);
    const size_desc = `${wheel?.diameter}'x'${wheel?.width}`;

    const packageTotal = useMemo(() => {
        return ((wheelPrice * 4) + (tirePrice * 4)).toFixed(2);
    }, [wheelPrice, tirePrice]);

    const wheelImages = [
        wheel?.image_url1,
        wheel?.image_url2,
        wheel?.image_url3,
        wheel?.image_url4,
    ].filter(Boolean);

    const [selectedImage, setSelectedImage] = useState(
        wheelImages[0] || ""
    );

    const defaultImage = "https://extremeperformance.com/images/no-image-found.png";

    let tireImage = selectedTire?.tire_image;

    if (!tireImage || tireImage.includes(".app.netsuite.com")) {
        tireImage = defaultImage;
    }


    const checkStock = (
        cartItems,
        product_id,
        addingQty,
        availableStock,
        itemName
    ) => {
        const currentQty = cartItems[product_id] || 0;
        const newTotal = currentQty + addingQty;

        if (newTotal > availableStock) {
            toast.info(
                `Cannot add more ${itemName}. Only ${availableStock} available in stock!`,
                {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                }
            );
            return false;
        }

        return true;
    };

    const addItem = async (
        product_id,
        product_price,
        quantity,
        category_type,
        image,
        vendor_id,
        total_quantity,
        product_name
    ) => {
        const cartItems =
            JSON.parse(localStorage.getItem("totalCartItems")) || {};

        const config = {
            method: "post",
            url: `${mainUrl}/api/add-to-cart`,
            withCredentials: true,
            params: {
                product_image: image,
                product_id,
                product_name,
                product_price,
                product_quantity: quantity,
                category_type,
                total_quantity,
                part_number: product_id,
                vendor_id: vendor_id || "",
            },
            data: {
                cart_key: localStorage.getItem("cart-key") || "",
                user_token: localStorage.getItem("user-token") || "",
            },
        };

        const response = await axios.request(config);

        cartItems[product_id] =
            (cartItems[product_id] || 0) + quantity;

        if (response.data.addCartResponse) {
            localStorage.setItem(
                "cart-key",
                response.data.addCartResponse
            );
        }

        localStorage.setItem(
            "totalCartItems",
            JSON.stringify(cartItems)
        );
    };

    const addPackageToCart = async () => {
        if (!selectedTire) return;

        setLoader(true);

        try {
            const cartItems =
                JSON.parse(localStorage.getItem("totalCartItems")) || {};

            const canAdd =
                checkStock(
                    cartItems,
                    wheel.sku,
                    PACKAGE_QTY,
                    wheel.wheel_quantity,
                    "Wheel"
                ) &&
                checkStock(
                    cartItems,
                    selectedTire.tire_item_id,
                    PACKAGE_QTY,
                    selectedTire.tire_quantity,
                    "Tire"
                );

            if (!canAdd) {
                setLoader(false);
                return;
            }

            await addItem(
                wheel.sku,
                wheel.price,
                PACKAGE_QTY,
                "wheel",
                wheel.image_url1,
                wheel.vendor_id,
                wheel.wheel_quantity,
                wheel.product_name || wheel.brand_desc
            );

            await addItem(
                selectedTire.tire_item_id,
                selectedTire.tire_price,
                PACKAGE_QTY,
                "tires_cat",
                // selectedTire.tire_image,
                tireImage,
                selectedTire.tire_vendor_id,
                selectedTire.tire_quantity,
                `${selectedTire.tire_brand} ${selectedTire.tire_model} ${selectedTire.tire_size}`
            );

            window.dispatchEvent(new Event("cartUpdated"));

            toast.success("Package Added to cart successfully!", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });

            setTimeout(() => {
                navigate("/add-cart");
            }, 1000);

            // window.open("/add-cart", "_blank");

        } catch (error) {
            console.error(error);
            toast.error("Failed to add package to cart");
        } finally {
            setLoader(false);
        }
    };

    const goToWheelDetails = () => {
        window.open(
            `/wheels-product-details/${wheel.sku}`,
            "_blank"
        );
    };

    const goToTireDetails = (tireId) => {
        window.open(
            `/tires-details/${tireId}`,
            "_blank"
        );
    };


    return (
        <div className="ep-page">

            {/* MAIN GRID */}
            <div className="ep-builder-layout">

                {/* CENTER CONTENT */}
                <main className="ep-main-content">

                    {/* WHEEL SECTION */}

                    <div className="ep-section-card">

                        <div className="ep-section-top">
                            <span className="ep-step">1</span>

                            <span className="ep-section-title">
                                Selected Wheel
                            </span>

                            <button
                                className="ep-edit-wheel-btn"
                                onClick={() => navigate(-1)}
                            >
                                Edit Wheel
                            </button>
                        </div>

                        <div className="ep-wheel-layout">
                            <div className="ep-wheel-image-col">

                                {/* <img
                                    src={selectedImage}
                                    alt={wheel?.style}
                                    className="ep-wheel-image"
                                /> */}

                                {selectedImage ? (
                                    <img
                                        src={selectedImage}
                                        alt={wheel?.style || "Wheel"}
                                        className="ep-wheel-image"
                                    />
                                ) : (
                                    <div className="ep-wheel-image placeholder">
                                        No Image Available
                                    </div>
                                )}
                                {/* <img
                                    src={selectedImage}
                                    alt={wheel?.style}
                                    className="ep-wheel-image"
                                    onClick={goToWheelDetails}
                                    style={{ cursor: "pointer" }}
                                /> */}

                                <div className="ep-wheel-thumbs">
                                    {wheelImages.map((img, index) => (
                                        <img
                                            key={index}
                                            src={img}
                                            alt={`Wheel ${index + 1}`}
                                            className={
                                                selectedImage === img
                                                    ? "active-thumb"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setSelectedImage(img)
                                            }
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="ep-wheel-details">

                                <div className="ep-wheel-brand">
                                    {wheel?.brand_desc}
                                </div>

                                <h2 className="ep-wheel-title">
                                    {`${wheel.brand_desc} ${wheel.style} ${wheel.fancy_finish_desc}  ${wheel.size_desc} ${wheel.wheel_offset}MM`}
                                </h2>

                                <div className="ep-wheel-spec-list">

                                    <div className="ep-spec-row">
                                        <span className="ep-spec-label">SIZE</span>
                                        <span className="ep-spec-value">
                                            {wheel?.diameter}x{wheel?.width}
                                        </span>
                                    </div>

                                    <div className="ep-spec-row">
                                        <span className="ep-spec-label">
                                            BOLT PATTERN
                                        </span>
                                        <span className="ep-spec-value">
                                            {wheel?.bolt_pattern_metric}
                                        </span>
                                    </div>

                                    <div className="ep-spec-row">
                                        <span className="ep-spec-label">
                                            FINISH
                                        </span>
                                        <span className="ep-spec-value">
                                            {wheel?.fancy_finish_desc || "N/A"}
                                        </span>
                                    </div>

                                    <div className="ep-spec-row">
                                        <span className="ep-spec-label">
                                            OFFSET
                                        </span>
                                        <span className="ep-spec-value">
                                            {wheel?.wheel_offset || "N/A"}
                                        </span>
                                    </div>

                                    <div className="ep-spec-row">
                                        <span className="ep-spec-label">
                                            LOAD RATING
                                        </span>
                                        <span className="ep-spec-value">
                                            {wheel?.load_rating || "N/A"}
                                        </span>
                                    </div>

                                </div>

                                <div className="ep-wheel-sku">
                                    SKU: {wheel?.sku}
                                </div>

                                <div className="ep-wheel-price">
                                    ${Number(wheel?.price || 0).toFixed(2)}
                                </div>

                                <a
                                    href="#"
                                    className="pkg-cta-btn danger mt-2"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        window.open(`/wheels-product-details/${wheel.sku}`, "_blank");
                                    }}
                                >
                                    View Details
                                </a>

                            </div>
                        </div>
                    </div>

                    {/* TIRE SECTION */}
                    <div className="ep-section-card">

                        <div className="ep-section-top">
                            <span className="ep-step">2</span>

                            <span className="ep-section-title">
                                Select Your Tire
                            </span>

                            <span className="ep-selected">
                                {tireOptions.length} Tires Available
                            </span>
                        </div>

                        <div className="ep-tire-list">

                            {tireOptions.map((tire) => {

                                const active =
                                    selectedTire?.tire_item_id ===
                                    tire.tire_item_id;

                                return (
                                    <div
                                        key={tire.tire_item_id}
                                        className={`ep-tire-card ${active
                                            ? "active"
                                            : ""
                                            }`}
                                        onClick={() =>
                                            setSelectedTire(
                                                tire
                                            )
                                        }
                                    >

                                        <div className="ep-radio">
                                            <div />
                                        </div>

                                        {/* <img
                                            src={
                                                tire.tire_image
                                            }
                                            alt=""
                                            className="ep-tire-image"
                                        /> */}

                                        {tire?.tire_image ? (
                                            <img
                                                src={tire.tire_image}
                                                alt={tire.tire_brand || "Tire"}
                                                className="ep-tire-image"
                                            />
                                        ) : (
                                            <div className="ep-tire-image placeholder">
                                                No Image Available
                                            </div>
                                        )}

                                        <div className="ep-tire-content">

                                            <div className="ep-tire-brand">
                                                {`${tire.tire_brand} ${tire.tire_model} ${tire.tire_size}`}
                                            </div>

                                            {/* <div
                                                className="ep-tire-brand"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    goToTireDetails(tire.tire_item_id);
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {`${tire.tire_brand} ${tire.tire_model} ${tire.tire_size}`}
                                            </div> */}



                                            <div className="ep-tire-size">
                                                {
                                                    tire.tire_size
                                                }
                                            </div>


                                            <div className="pkg-tire-sku">
                                                SKU: {tire.tire_sku}
                                            </div>



                                            {/* <div className="ep-stars">
                                                ★★★★★
                                                <span>
                                                    (124)
                                                </span>
                                            </div> */}

                                            <div className="ep-stock">
                                                <i className="fa fa-industry text-success" aria-hidden="true"></i>{" "}
                                                {tire.tire_quantity}
                                            </div>

                                        </div>

                                        <div className="ep-tire-price">
                                            <div >${Number(tire.tire_price).toFixed(2)}<span style={{ fontSize: "14px" }}>/each</span></div>

                                            {/* <button
                                                className="pkg-cta-btn btn btn-danger w-100 p-1 mt-2"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    goToTireDetails(tire.tire_item_id);
                                                }}
                                            >
                                                View Details
                                            </button> */}

                                            <a
                                                href="#"
                                                className="pkg-cta-btn danger mt-2"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    window.open(`/tires-details/${tire.tire_item_id}`, "_blank");
                                                }}
                                            >
                                                View Details
                                            </a>


                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </main>

                {/* SUMMARY */}

                <aside className="ep-summary-sidebar">
                    <div className="ep-summary-card">

                        <div className="ep-summary-header">
                            PACKAGE SUMMARY
                        </div>

                        {/* Wheel */}

                        <div className="ep-summary-product">
                            {/* <img
                                src={wheel?.image_url1}
                                alt={wheel?.brand_desc}
                                className="ep-summary-product-image"
                            /> */}
                            {wheel?.image_url1 ? (
                                <img
                                    src={wheel.image_url1}
                                    alt={wheel?.brand_desc || "Wheel"}
                                    className="ep-summary-product-image"
                                />
                            ) : (
                                <div className="ep-summary-product-image placeholder">
                                    No Image Available
                                </div>
                            )}

                            <div className="ep-summary-product-info">

                                <div className="ep-summary-product-label">
                                    Wheel (4)
                                </div>

                                <div className="ep-summary-product-name">
                                    {wheel?.brand_desc}
                                </div>

                                <div className="ep-summary-product-spec">
                                    {wheel?.diameter}x{wheel?.width}
                                    {" | "}
                                    {wheel?.wheel_offset}mm
                                </div>

                            </div>

                            <div className="ep-summary-product-price">
                                ${(wheelPrice * 4).toFixed(2)}
                            </div>
                        </div>

                        {/* Tire */}

                        {selectedTire && (
                            <div className="ep-summary-product">

                                {/* <img
                                    src={selectedTire?.tire_image}
                                    alt={selectedTire?.tire_brand}
                                    className="ep-summary-product-image"
                                /> */}

                                {selectedTire?.tire_image ? (
                                    <img
                                        src={selectedTire.tire_image}
                                        alt={selectedTire.tire_brand}
                                        className="ep-summary-product-image"
                                    />
                                ) : (
                                    <div className="ep-summary-product-image placeholder">
                                        No Image Available
                                    </div>
                                )}

                                <div className="ep-summary-product-info">

                                    <div className="ep-summary-product-label">
                                        Tire (4)
                                    </div>

                                    <div className="ep-summary-product-name">
                                        {selectedTire?.tire_brand}
                                    </div>

                                    <div className="ep-summary-product-spec">
                                        <strong>SKU: </strong>{selectedTire?.tire_sku}
                                    </div>

                                </div>

                                <div className="ep-summary-product-price">
                                    ${(tirePrice * 4).toFixed(2)}
                                </div>

                            </div>
                        )}

                        <div className="ep-summary-total">

                            <label>PACKAGE TOTAL</label>

                            <div>${packageTotal}</div>

                        </div>

                        {!loader ? (
                            <button
                                className="ep-cart-btn"
                                onClick={addPackageToCart}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2.2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <circle cx="9" cy="21" r="1" />
                                    <circle cx="20" cy="21" r="1" />
                                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                                </svg>
                                ADD PACKAGE TO CART
                            </button>
                        ) : (
                            <button
                                className="ep-cart-btn"
                                disabled
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                />
                                ADDING TO CART...
                            </button>
                        )}


                    </div>
                </aside>


            </div>

        </div>
    );
}